import type { UpdateUserPayload } from '../models';
import type { UpdateUserPayloadDto } from '../dto';

export function mapUpdateUserPayloadToDto(payload: UpdateUserPayload): UpdateUserPayloadDto {
  return {
    first_name: payload.firstName,
    last_name: payload.lastName,
    role_id: payload.roleId,
    firm_id: payload.firmId,
    active: payload.active,
  };
}
